import * as R from 'ramda';

export default function AuthorityAndManagementController(
  $q,
  $rootScope,
  $scope,

  confirmDialog,
  alerts,
  orgDataService,
  bcpDataService,
  editAuthorityAndManagementDialog,
  editInternalContactDialog,
  loaderService,
  ssDialogService,
  userService,
  bcpUtilityService
) {
  const vm = this;

  vm.isExpanded = false;
  vm.hasData = false;
  vm.showFilters = true;

  vm.handleExpandAuthorityAndManagement = _handleExpandAuthorityAndManagement;
  vm.handleAddInternalContactClick = _handleAddInternalContactClick;
  vm.handleEditAuthorityAndManagementClick = _handleEditAuthorityAndManagementClick;
  vm.handleEditInternalContactClick = _handleEditInternalContactClick;
  vm.handleShowConfirmDeleteInternalContactDialogClick = _handleShowConfirmDeleteInternalContactDialogClick;
  vm.refreshInternalContacts = _refreshInternalContacts;

  _activate();

  // //////// HANDLERS //////////

  function _handleExpandAuthorityAndManagement() {
    if (vm.hasData) {
      vm.isExpanded = !vm.isExpanded;
    } else {
      loaderService.showViewLoader = true;
      _refreshInternalContacts().then(() => {
        vm.hasData = true;
        vm.isExpanded = true;
        loaderService.showViewLoader = false;
      });
    }
  }

  function _handleAddInternalContactClick($event) {
    ssDialogService.dialogs.bcp.editInternalContactDialog = ssDialogService.alert(
      editInternalContactDialog.getOptions($event, {
        user: {
          userId: 0,
          authenticationSource: 'None',
          customerId: vm.customerId,
        },
      })
    );
    ssDialogService.show(ssDialogService.dialogs.bcp.editInternalContactDialog);
  }

  function _handleEditAuthorityAndManagementClick($event) {
    loaderService.showViewLoader = true;

    _refreshInternalContacts().then(() => {
      ssDialogService.dialogs.bcp.editAuthorityAndManagementDialog = ssDialogService.alert(
        editAuthorityAndManagementDialog.getOptions($event, {
          customerId: vm.customerId,
          assessmentId: vm.assessmentId,
          internalContacts: vm.internalContacts,
          permissions: vm.permissions,
        })
      );
      loaderService.showViewLoader = false;
      ssDialogService.show(ssDialogService.dialogs.bcp.editAuthorityAndManagementDialog);
    });
  }

  function _handleEditInternalContactClick($event, user) {
    ssDialogService.dialogs.bcp.editInternalContactDialog = ssDialogService.alert(
      editInternalContactDialog.getOptions($event, {
        user,
      })
    );
    ssDialogService.show(ssDialogService.dialogs.bcp.editInternalContactDialog);
  }

  function _handleShowConfirmDeleteInternalContactDialogClick($event, user) {
    ssDialogService.dialogs.bcp.confirmDeleteInternalContactDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete User?',
        message: `Are you sure you want to delete the user "${user.fullName}"?`,
        handleYesClick: () => {
          _handleYesDeleteInternalContactDialogClick(user.userId);
        },
        handleNoClick: () => {
          _handleCloseConfirmDeleteInternalContactDialogClick();
        },
      })
    );
    ssDialogService.show(ssDialogService.dialogs.bcp.confirmDeleteInternalContactDialog);
  }

  function _handleYesDeleteInternalContactDialogClick(userId) {
    loaderService.showViewLoader = true;
    const dfdDeleteUser = orgDataService.deleteUser(userId);
    dfdDeleteUser.then((deleteUserResponse) => {
      if (deleteUserResponse.status === 200) {
        alerts.success('Internal Contact has been deleted successfully.');
        $rootScope.$broadcast('refreshInternalContacts');
        $rootScope.$broadcast('refreshUsers');
      } else {
        alerts.error('Error occurred while deleting Internal Contact.');
      }
      loaderService.showViewLoader = false;
      _handleCloseConfirmDeleteInternalContactDialogClick();
    });
  }

  function _handleCloseConfirmDeleteInternalContactDialogClick() {
    ssDialogService.hide(ssDialogService.dialogs.bcp.confirmDeleteInternalContactDialog);
  }

  // //////// PRIVATE METHODS //////////

  function _activate() {
    _initEventListeners();
    _initPermissions();
    _initFilters();
  }

  function _initEventListeners() {
    $scope.$on(
      'refreshInternalContacts',
      _refreshInternalContacts
    );
  }

  function _initPermissions() {
    userService.getUserPermissionSet('bcp').then((bcpPermissions) => {
      vm.permissions = bcpPermissions;
    });
    userService.getUserPermissionSet('admin').then((adminPermissions) => {
      vm.permissions = R.merge(vm.permissions, adminPermissions);
    });
  }

  function _initFilters() {
    _resetFilters();
  }

  function _resetFilters() {
    vm.contactFilters = {
      includeInitialResponseTeam: true,
      includeCrisisManagementTeam: true,
      includeDepartmentRecoveryTeam: true,
      includeNoTeam: true,
    };
  }

  function _refreshInternalContacts() {
    const dfdContactRefresh = $q.defer();
    bcpDataService.getAuthorityAndManagement(
      vm.assessmentId
    ).then((getAuthorityAndManagementResponse) => {
      vm.internalContacts = bcpUtilityService.transformInternalUsersData(getAuthorityAndManagementResponse.data);
      dfdContactRefresh.resolve();

      $rootScope.$broadcast('internalContactsRefreshed', vm.internalContacts);
    });
    return dfdContactRefresh.promise;
  }
}

AuthorityAndManagementController.$inject = [
  '$q',
  '$rootScope',
  '$scope',

  'confirmDialog',
  'alerts',
  'orgDataService',
  'bcpDataService',
  'editAuthorityAndManagementDialog',
  'editInternalContactDialog',
  'loaderService',
  'ssDialogService',
  'userService',
  'bcpUtilityService',
];
